/**
 * Softphone DevTools store - Zustand store for panel open state
 *
 * Replaces the previous React Context. Whether the panel exists at all is not
 * decided here: `SoftphoneDevTools` gates on the "Enable softphone diagnostics
 * panel" setting (CUU2-3511) and mounts nothing without it, so by the time any
 * of this state is read, access has already been established.
 */

import type { DevToolsStore } from 'Modules/softphone/components/SoftphoneDevTools/store/index.types';
import { create } from 'zustand';

export const useDevToolsStore = create<DevToolsStore>((set) => ({
  isOpen: false,
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
